<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <PedidosAdmin></PedidosAdmin>
</v-col>
</v-row>
</v-container>
</div>
</template>

<script>
import PedidosAdmin from '@/components/tienda/pedido/PedidosAdmin.vue';

export default {
  data() {
    return {}
  },
  components: {
    PedidosAdmin
  },
  methods: {}
}
</script>
